import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SecuredImageU2bModule } from '@shared/components/secured-image-u2b/secured-image-u2b.module';
import { TranslationModule } from '@core/translation/translation.module';
import { MyProfileDialogComponent } from './my-profile-dialog.component';

@NgModule({
    declarations: [
        MyProfileDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        SecuredImageU2bModule,
        TranslationModule,
    ],
    exports: [
        MyProfileDialogComponent,
    ],
})
export class MyProfileDialogModule {}
